<template>
  <div class="obj_item" :class="(hide)? 'list-is-hide':''">
    <div class="obj_title" @click="toggleobjList" >
      <span class="obj_title_text"><slot name="title"/></span>
      <span class="obj_title_link"><slot name="cnt" /></span>
    </div>
    <ul class="obj_list">
      <li v-for="(obj,key) in list" :key="key" class="obj_list_item">
        <a
          v-if="type_list != 'trigger'"
          class="obj_list_link"
          :href="check_link(obj)"
          target="_blank"
        >
          <span v-if="type == 'html'" v-html="check_name(obj)" />
          <span v-else>{{check_name(obj)}}</span>
        </a>

        <span
          class="obj_list_link"
          v-else
        >
          {{check_name(obj)}}
        </span>

      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'hidden-list-notif',
  props: {
    list: [Object, Array],
    type_list: String,
    index: Number,
    type: String
  },
  data () {
    return {
      hide: true
    }
  },
  methods: {
    toggleobjList () {
      this.hide = !this.hide
    },
    check_name(obj){
      let name = ''
      if(typeof(obj.name) != "undefined" && obj.name !== null && obj.name !== '') {
        name += obj.name + ' '
      }
      if(typeof(obj.name2) != "undefined" && obj.name2 !== null && obj.name2 !== '') {
        name += obj.name2
      }
      if (name !== '') {
        return name
      }
      return 'no name'
    },
    check_link(obj){
      let link = ''
      if(typeof(obj.fid) != "undefined" && obj.fid !== null && obj.fid !== '') {
        link = '#/device/'+obj.fid+'/profile'
        return link
      }
      if(typeof(obj.id) != "undefined" && obj.id !== null && obj.id !== '') {
        link = '#/device_group/'+obj.id
        return link
      }
      return ''
    }
  },
  computed:{

  }
}
</script>

<style lang="scss">

  .obj{
    &_item{
      position: relative;

    }
    &_title{
      color: #000;
      font: italic 1.25rem/1.5rem Roboto,Arial,sans-serif;
      border-bottom: 1px dotted #66615b;
      cursor: pointer;
      white-space: nowrap;
      &_text{
        margin-right: 5px;
      }
      &_link{

        &::after {
          content: "↑";
          display: inline-block;
          vertical-align: middle;
          font-size: 0.9rem;
          font-weight: 700;
          color: rgb(102, 102, 102);
          transform: rotate(180deg);
          padding: 0 .25rem 0 0;
          transition: transform 0.3s ease 0s, -webkit-transform 0.3s ease 0s;
        }
      }

    }
    &_list{
      position: absolute;
      opacity: 1;
      max-height: none;
      transition: .15s ease,opacity .3s ease,all;
      background-color: white;
      padding: 10px;
      text-align: end;
      border-radius: 10px;
      z-index: 10;
      box-shadow: 0 2px 2px #ccc5b980;
      width: max-content;
      &_item{
        display: block;
        margin: 0;
      }
    }

  }

  .list-is-hide{
    .obj{
      &_list{
        opacity: 0;
        max-height: 0;
        z-index: -10;
      }
      &_title{
        &_text{

        }
        &_link{
          &::after {
            transform: rotate(0deg);
            padding: 0px 0px 0px 0.25rem;
          }
        }

      }
    }
  }

</style>
